import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Broadcaster} from './broadcaster';

// This broadcast using for sliding the menu and screen together
@Injectable()
export class MessageEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(MessageEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(MessageEvent);
  }
}

// Hide menu on sign in and sign up page
@Injectable()
export class SignInEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(SignInEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(SignInEvent);
  }
}

// Using for show loader while page uploading on browser
@Injectable()
export class LoaderEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(LoaderEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(LoaderEvent);
  }
}

// Using for load one time facilities for menu page
@Injectable()
export class FacilityListEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(FacilityListEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(FacilityListEvent);
  }
}

// Using for close side menu while opening new frame
@Injectable()
export class OpenFrameEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(OpenFrameEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(OpenFrameEvent);
  }
}

// This broadcast passing data DatePicker to calendar

@Injectable()
export class DatePickerToCalendarEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(DatePickerToCalendarEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(DatePickerToCalendarEvent);
  }
}

// This broadcast passing data between sidemnu to calendar

@Injectable()
export class SidemenuToCalendarEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(SidemenuToCalendarEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(SidemenuToCalendarEvent);
  }
}

@Injectable()
export class SidemenuToViewFacilityEvent {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(SidemenuToViewFacilityEvent, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(SidemenuToViewFacilityEvent);
  }
}

@Injectable()
export class SidemenuSubCategory {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(SidemenuSubCategory, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(SidemenuSubCategory);
  }
}

@Injectable()
export class HandleSideMenuWithAuth {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(HandleSideMenuWithAuth, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(HandleSideMenuWithAuth);
  }
}

@Injectable()
export class HiddenFooter {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(HiddenFooter, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(HiddenFooter);
  }
}

@Injectable()
export class SetAllMemberCheck {
  constructor(private broadcaster: Broadcaster) {}

  fire(data: any): void {
    this.broadcaster.broadcast(SetAllMemberCheck, data);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(SetAllMemberCheck);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/message.event.ts